module.exports = __webpack_public_path__ + "img/Скобка_two_lines.15dd9fb7.svg";